'use client';

import AnimatedConditional from '@/@shared/components/primitives/Animation/AnimatedConditional';
import Icon from '@/Icon';
import { addLayer } from '@/legacy/components/apps/ClientModalProvider';
import DiagonalViewportModal from '@/legacy/components/apps/DiagonalViewportModal';
import { freezeAtom } from '@/legacy/components/apps/Freeze';
import { store } from '@/legacy/components/apps/Jotai';
import { clc, setClassCurry, type BaseProps } from '@/legacy/components/base/utils';
import KebabModal, { KEBAB_KEY } from '@/legacy/components/modalContents/KebabModal';
import styles from '@/legacy/components/widget/Header.module.scss';
import ProfileBtn from '@/legacy/components/widget/ProfileBtn';
import { useGetCurrentOwner } from '@/model/dexie/ownerDexie';
import { promiseNotNullCheck } from '@/utilities/stateTool';
import { atom, useAtomValue } from 'jotai';
import Link from 'next/link';
import { useParams } from 'next/navigation';

export const colorAtom = atom<'white' | 'black' | 'feed'>('white');
export const menuVisibleAtom = atom(true);
export const logoVisibleAtom = atom(true);
export const backgroundAtom = atom<'white' | 'black' | 'transparent'>('transparent');

export const headerColorSet = (data: 'white' | 'black' | 'feed') => store.set(colorAtom, data);
export const menuVisibleSet = (data: boolean) => store.set(menuVisibleAtom, data);
export const logoVisibleSet = (data: boolean) => store.set(logoVisibleAtom, data);
export const backgroundSet = (data: 'white' | 'black' | 'transparent') => store.set(backgroundAtom, data);

const keBabColorKey = {
	black: '#1A1A20',
	feed: '#1A1A20',
	white: '#FDFDFE',
};

const Header = ({ children, ...props }: BaseProps['header']) => {
	const bgColor = useAtomValue(backgroundAtom);
	const themeColor = useAtomValue(colorAtom);
	const logoVisible = useAtomValue(logoVisibleAtom);
	const { locale } = useParams<{ locale: string }>();
	const isFreeze = useAtomValue(freezeAtom);
	const c = setClassCurry(styles.flexRow, styles[themeColor]);

	const current = useGetCurrentOwner();

	const modalOpen = (target: HTMLElement) => {
		addLayer(
			KEBAB_KEY,
			<DiagonalViewportModal align="right" axis="bottomLeft" offset={16} target={target}>
				<KebabModal locale={locale} />
			</DiagonalViewportModal>,
			{
				escapeActive: true,
				freeze: false,
				outsideDismiss: true,
				style: {
					alignItems: 'flex-start',
					backgroundColor: 'transparent',
					justifyContent: 'flex-start',
				},
			}
		);
	};

	return (
		<header {...props} className={c(styles.header, styles['bg' + bgColor], isFreeze && styles.lock)}>
			{logoVisible && (
				<Link className={c(styles.logo)} href={'/' + locale}>
					<Icon path="ICON_64_Logo_None" />
				</Link>
			)}

			{/* 비즈니스 계정 파악 필요 */}

			<AnimatedConditional
				show={promiseNotNullCheck(current) && current.authority !== 'USER'}
				animation="scale-spring"
				duration={0.4}
			>
				<Icon className={clc(styles.centerCrown)} path="Sticker_Business_Crown_32" />
			</AnimatedConditional>

			{/* <div className={menuVisible ? c(menuColor) : styles.hide}>
				<Link href={'/' + locale + '/'} className={c(styles.text, isRoot && styles.active)}>
					Tournament
				</Link>
				<Link href={'/' + locale + '/shop'} className={c(styles.text, isShop && styles.active)}>
					Shop
				</Link>
				<Link href={'/' + locale + '/feed'} className={c(styles.text, isFeed && styles.active)}>
					Feed
				</Link>
			</div> */}

			<div className={styles.sign}>
				<ProfileBtn className={styles.signIn} />

				<button className={styles.kebab} onClick={(e) => modalOpen(e.currentTarget)}>
					<Icon className={styles.kebab} color1={keBabColorKey[themeColor]} path="Action_Kebab_48_White" />
				</button>
			</div>
		</header>
	);
};

export default Header;
